module.exports = __webpack_public_path__ + "static/media/sc.858e7309.svg";